import { useTranslation } from 'react-i18next';
import { useGetRecordQuery } from '@platform/state/api';
import { ErrorBanner, Spinner } from '@platform/ui';
import { RecordBreadcrumbs } from './header/RecordBreadcrumbs';
import type { ISavedRecordPageProps } from './ISavedRecordPageProps';
import { RecordView } from './RecordView';
import { useRecordRelocation } from './useRecordRelocation';

/**
 * Сторінка збереженого запису: крихти «… › Модуль › Тип код», запис (GET) і його повна форма; помилка — банер, завантаження — індикатор.
 * Запис з іншого простору відкривається в ньому (useRecordRelocation, ADR-028).
 */
export function SavedRecordPage({ ws, rtKey, id, tab, module, rt }: ISavedRecordPageProps) {
  const { t } = useTranslation();
  const { data: record, isLoading, error } = useGetRecordQuery({ ws, rt: rtKey, id });
  const relocating = useRecordRelocation(ws, rtKey, id, tab, error);
  return (
    <>
      <div className="rec__crumbs"><RecordBreadcrumbs rt={rt} record={record} /></div>
      {module && record && rt
        ? <RecordView key={record.id} ws={ws} module={module} rt={rt} record={record} tab={tab} />
        : <div className="rec__state">{isLoading || relocating || !module ? <Spinner /> : <ErrorBanner error={error ?? { message: t('app.notFound') }} />}</div>}
    </>
  );
}
